import { useEffect, useState } from "react";
import { QUERY_USER_TRANSACTION } from "../../../lib/query_obj";
import {
  GetDataFromServer,
  GetDataListFromServer,
  UpdateSingleDataOnServer,
} from "../../../lib/api";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Typography,
} from "antd";
import { moneyFormat, queryHandler } from "../../../lib/global_functions";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  AGENT_LIST,
  GAME_WALLET_TO_MAIN_WALLET,
  USER_TRANSACTION_LIST,
} from "../../../lib/config";
import moment from "moment-timezone";
import DepositModal from "../../transaction/depositModal";
import WithdrawModal from "../../transaction/withdrawModal";
import { resetTransactionNoti, setState } from "../../../redux/user";
import ExpandableContent from "../../transaction/expandable_content";
import ConfirmForm from "./confirm_form";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { Text } = Typography;
const { Option } = Select;
export default function UserTransaction({ detail, closeDrawer }) {
  console.log("detail...", detail);
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [totalData, setTotalData] = useState({ deposit: 0, withdraw: 0 });
  const [showDepositForm, setShowDepositForm] = useState(false);
  const [showWithdrawForm, setShowWithdrawForm] = useState(false);

  const [depositData, setDepositData] = useState(false);
  const [withdrawData, setWithDrawData] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [confirmData, setConfirmData] = useState(false);

  const [rejectData, setRejectData] = useState(false);

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });
  const [filter, setFilter] = useState({
    name: "",
    user_id: detail.id,
    is_finish: "TRUE",
    type: "",
    start_date: "",
    end_date: "",
  });

  async function getRefreshDataList() {
    await GetDataFromServer(AGENT_LIST, user.access_token)
      .then((res) => {
        dispatch(
          setState({
            ...user,
            points: res.data.points,
            total_deposit_points: res.data.total_deposit_points,
            total_withdraw_points: res.data.total_withdraw_points,
          })
        );
      })
      .catch((error) => {
        toast.error(error?.response.data || "Connection Error");
      });
  }

  async function getDataList(page_number, per_page, updateFilter) {
    const currentFilter = updateFilter || filter;
    const queryFilter = {
      ...currentFilter,
      start_date: currentFilter.start_date
        ? moment
            .tz(currentFilter.start_date, "Asia/Yangon")
            .startOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : "",
      end_date: currentFilter.end_date
        ? moment
            .tz(currentFilter.end_date, "Asia/Yangon")
            .endOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : "",
    };

    setLoading(true);
    await GetDataListFromServer(
      USER_TRANSACTION_LIST,
      queryHandler(queryFilter, QUERY_USER_TRANSACTION, {
        page_number,
        per_page,
      }),
      user.access_token
    )
      .then(({ data: { data: res, total, total_data } }) => {
        setLoading(false);
        updateFilter && setFilter(updateFilter);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(res);

        const deposit = total_data.find(
          (item) => item.transaction_type === "DEPOSIT"
        )?.total;
        const withdraw = total_data.find(
          (item) => item.transaction_type === "WITHDRAW"
        )?.total;

        setTotalData({
          deposit: deposit,
          withdraw: withdraw,
        });

        dispatch(resetTransactionNoti());
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
    getRefreshDataList();
  }, []);

  useEffect(() => {
    if ((user.playing_user_ids || user.user_play_game_id) && list.length > 0) {
      const updatedList = list.map((item) => {
        if (user.playing_user_ids.includes(item.user_id)) {
          return { ...item, user_current_point: "0", play_game: true };
        }
        if (item.user_id === user.user_play_game_id) {
          return {
            ...item,
            user_current_point: user.user_points,
            play_game: user.play_game,
          };
        }
        return item;
      });

      setList(updatedList);
    }
  }, [user.playing_user_ids, user.user_play_game_id]);

  useEffect(() => {
    if (user.transaction_noti) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }, [user.transaction_noti]);

  function confirmHandler(record, type) {
    setShowForm(true);
    if (type === "accept") {
      setConfirmData(record);
    } else {
      setRejectData(record);
    }
  }

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOption(value) {
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={iconPath}
          alt={value}
          style={{ width: 30, height: 30, marginRight: 8, borderRadius: "5px" }}
        />
      </div>
    );
  }

  const columns = [
    {
      title: "Transaction Type",
      dataIndex: "type",
      render: (record) => {
        return (
          <Text style={{ color: record === "DEPOSIT" ? "lime" : "orange" }}>
            {record}
          </Text>
        );
      },
    },
    {
      title: "User Code",
      dataIndex: "user_code",
      render: (record) => {
        return <Text>{record ? record : "-"}</Text>;
      },
    },

    {
      title: "User Before Transaction Points",
      dataIndex: "old_points",
      render: (record) => {
        return <Text>{moneyFormat(record)}</Text>;
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (_, record) => (
        <span>
          {moneyFormat(record.amount)}
          <Text style={{ color: "green" }}> ({record.currency})</Text>
        </span>
      ),
    },

    {
      title: "Is Approved?",
      dataIndex: "is_approved",
      render: (_, record) => {
        const { is_finish, is_approved } = record;
        let status, color, textColor;

        switch (true) {
          case !is_finish:
            status = "Pending";
            color = "gold";
            textColor = "gold";
            break;
          case is_approved:
            status = "Accept";
            color = "lime";
            textColor = "lime";
            break;
          default:
            status = "Reject";
            color = "magenta";
            textColor = "magenta";
        }

        return (
          <Tag color={color}>
            <Text style={{ color: textColor }}>{status}</Text>
          </Tag>
        );
      },
    },
    {
      title: "Last Deposit Bank Type",
      render: (_, record) => {
        if (record.last_deposit_bank_type !== null) {
          return renderBankOption(record.last_deposit_bank_type) || "-";
        }
        return "-";
      },
    },
    {
      title: "Date",
      dataIndex: "updated_at",
      render: (record) => {
        return moment
          .utc(record)
          .tz("Asia/Yangon")
          .format("DD-MM-YYYY, HH:mm:ss");
      },
    },
    // {
    //   title: "Now Playing?",
    //   dataIndex: "play_game",
    //   render: (record) => {
    //     return (
    //       <Tag color={record ? "lime" : "red"}>
    //         <Text style={{ color: record ? "lime" : "red" }}>
    //           {record ? "Yes" : "No"}
    //         </Text>
    //       </Tag>
    //     );
    //   },
    // },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   width: "100px",
    //   render: (_, record) => (
    //     <Row justify="end">
    //       <Space>
    //         {/* {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") && (
    //           <Popconfirm
    //             title="Are you sure to change game wallet to main wallet?"
    //             okText="Yes"
    //             cancelText="No"
    //             onConfirm={() => updateWalletHandler(record.user_id)}
    //           >
    //             <Button
    //               disabled={
    //                 record.play_game ||
    //                 user.playing_user_ids.includes(record.user_id)
    //               }
    //               size={user.ui_size}
    //               type="primary"
    //             >
    //               Game To Main Wallet
    //             </Button>
    //           </Popconfirm>
    //         )} */}

    //         {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") && (
    //           <Button
    //             size={user.ui_size}
    //             onClick={() => confirmHandler(record, "accept")}
    //             disabled={
    //               record.is_finish &&
    //               (record.is_approved || !record.is_approved)
    //             }
    //             type="primary"
    //           >
    //             Accept
    //           </Button>
    //         )}

    //         {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") && (
    //           <Button
    //             size={user.ui_size}
    //             disabled={
    //               record.is_finish &&
    //               (!record.is_approved || record.is_approved)
    //             }
    //             type="primary"
    //             onClick={() => confirmHandler(record, "reject")}
    //           >
    //             Reject
    //           </Button>
    //         )}
    //       </Space>
    //     </Row>
    //   ),
    // },
  ];

  async function updateWalletHandler(id) {
    setLoading(true);
    await UpdateSingleDataOnServer(
      GAME_WALLET_TO_MAIN_WALLET,
      id,
      user.access_token,
      user.csrf_token
    )
      .then(() => {
        setLoading(false);
        toast.success("Updated game wallet to main wallet successfully");
      })
      .catch(() => {
        setLoading(false);
        toast.error("Update Failed");
      });
  }

  function openDepositHandler() {
    setShowDepositForm(true);
    setDepositData(detail);
  }

  function openWithdrawHandler() {
    setShowWithdrawForm(true);
    setWithDrawData(detail);
  }

  function closeDrawer() {
    setShowForm(false);
    setConfirmData(false);
    setRejectData(false);
  }

  function closeModal(key) {
    setShowDepositForm(false);
    setShowWithdrawForm(false);
    if (key) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }

  function clearFilter() {
    getDataList(pagin.page_number, pagin.per_page, {
      ...filter,
      type: "",
      start_date: "",
      end_date: "",
    });
  }

  return (
    <>
      <Row gutter={[16, 24]} justify="end">
        <Col span={24}>
          <Row gutter={[12, 12]}>
            <Col span={5}>
              <Text style={{ fontSize: "1.3rem", color: "cyan" }}>
                Agent Point : {moneyFormat(user.points)}
              </Text>
            </Col>

            <Row align={"middle"}>
              <Col>
                <Text>Date : &nbsp;</Text>
              </Col>
              <Col>
                <DatePicker.RangePicker
                  size={user.ui_size}
                  style={{ width: "300px" }}
                  format={"YYYY-MM-DD"}
                  value={[
                    filter.start_date
                      ? dayjs(filter.start_date, "YYYY-MM-DD")
                      : null,
                    filter.end_date
                      ? dayjs(filter.end_date, "YYYY-MM-DD")
                      : null,
                  ]}
                  onChange={(dates) => {
                    setFilter({
                      ...filter,
                      start_date: dates?.[0]?.format("YYYY-MM-DD") || "",
                      end_date: dates?.[1]?.format("YYYY-MM-DD") || "",
                    });
                  }}
                />
              </Col>
            </Row>

            <Row align="middle">
              <Col style={{ marginLeft: "20px" }}>
                <Text>Transaction Type : &nbsp;</Text>
              </Col>
              <Col>
                <Select
                  size={user.ui_size}
                  placeholder="Select Type"
                  style={{ width: "150px" }}
                  value={filter.type || undefined}
                  onChange={(value) => setFilter({ ...filter, type: value })}
                  allowClear={false}
                >
                  <Option value="DEPOSIT">Deposit</Option>
                  <Option value="WITHDRAW">Withdraw</Option>
                </Select>
              </Col>
            </Row>

            <Col style={{ marginLeft: "20px" }}>
              <Space>
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => {
                    getDataList(1, pagin.per_page);
                  }}
                >
                  Search
                </Button>
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => clearFilter()}
                >
                  Clear
                </Button>
              </Space>
            </Col>

            <Col span={24} style={{ marginTop: "20px" }}>
              <Row>
                <Col span={12}>
                  <Row align={"middle"} justify={"space-evenly"}>
                    <Col>
                      <Text style={{ fontSize: "1.3rem", color: "green" }}>
                        Total Deposit = {moneyFormat(totalData.deposit || 0)}
                      </Text>
                    </Col>
                    {user.permissions.includes(
                      "AGENT_CREATE_USER_TRANSACTION"
                    ) && (
                      <Col>
                        <Button
                          size={user.ui_size}
                          icon={<PlusOutlined />}
                          type="primary"
                          onClick={openDepositHandler}
                        >
                          Deposit
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col span={12}>
                  <Row align={"middle"} justify={"space-evenly"}>
                    <Col>
                      <Text style={{ fontSize: "1.3rem", color: "red" }}>
                        Total Withdraw = {moneyFormat(totalData.withdraw || 0)}
                      </Text>
                    </Col>
                    {user.permissions.includes(
                      "AGENT_CREATE_USER_TRANSACTION"
                    ) && (
                      <Col>
                        <Button
                          size={user.ui_size}
                          icon={<PlusOutlined />}
                          type="primary"
                          onClick={openWithdrawHandler}
                        >
                          Withdraw
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table
            size={user.ui_size}
            loading={loading}
            columns={columns}
            dataSource={list}
            rowKey={(e) => e.id}
            pagination={{
              total: pagin.total,
              current: pagin.page_number,
              pageSize: pagin.per_page,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50],
              onChange: (pageNumber, perPage) => {
                getDataList(pageNumber, perPage);
              },
              onShowSizeChange: (current, size) => {
                getDataList(1, size);
              },
            }}
            expandable={{
              expandedRowRender: (record) => (
                <ExpandableContent record={record} />
              ),
            }}
          />
        </Col>
      </Row>

      <Modal
        footer={null}
        title={
          <Row
            justify="space-between"
            align="middle"
            style={{ margin: "25px 0px" }}
          >
            <Col>
              <Text style={{ fontSize: "15px", fontWeight: "bold" }}>
                Deposit Form
              </Text>
            </Col>
            <Col>
              <Text
                type="success"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                Agent Points: {moneyFormat(user.points)}
              </Text>
            </Col>
          </Row>
        }
        open={showDepositForm}
        width={650}
        onCancel={() => setShowDepositForm(false)}
        destroyOnClose
      >
        <DepositModal closeDrawer={closeModal} detail={depositData} />
      </Modal>

      <Modal
        footer={null}
        title={
          <Row
            justify="space-between"
            align="middle"
            style={{ margin: "25px 0px" }}
          >
            <Col>
              <Text style={{ fontSize: "15px", fontWeight: "bold" }}>
                Withdraw Form
              </Text>
            </Col>
            <Col>
              <Text
                type="success"
                style={{ fontSize: "16px", fontWeight: "bold" }}
              >
                User Points: {moneyFormat(withdrawData.wallet?.points || 0)}
              </Text>
            </Col>
          </Row>
        }
        width={650}
        open={showWithdrawForm}
        onCancel={() => setShowWithdrawForm(false)}
        destroyOnClose
      >
        <WithdrawModal closeDrawer={closeModal} detail={withdrawData} />
      </Modal>

      <Drawer
        open={showForm}
        title={confirmData ? "Accept Form" : "Reject Form"}
        width={560}
        destroyOnClose
        onClose={() => closeDrawer()}
      >
        <ConfirmForm
          closeDrawer={closeDrawer}
          detail={detail}
          confirmData={confirmData}
          rejectData={rejectData}
          getDataList={() => getDataList(pagin.page_number, pagin.per_page)}
        />
      </Drawer>
    </>
  );
}
